// Ordway-specific plan data, split out of the shared `billing/plans.ts` so a future
// billing vendor can live alongside it. Ported from the Ember UI (`app/utils/billing/plans.ts`).

// oxlint-disable local-rules/filename-match-export -- ordway/plans.ts groups Ordway-specific plan constants by vendor; its single export intentionally does not match the filename
export const OrdwayBillingPeriod = {
  Monthly: 'Monthly',
  Quarterly: 'Quarterly',
  SemiAnnually: 'Semi-Annually',
  Annually: 'Annually',
} as const;
export type OrdwayBillingPeriod = (typeof OrdwayBillingPeriod)[keyof typeof OrdwayBillingPeriod];
